// third-party
import { combineReducers } from 'redux';

// project import
import auth from './auth';
import menu from './menu';
import settings from './settings';

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({ auth, menu, settings });

export default reducers;
